export default __webpack_public_path__ + "static/media/MacStrommerResume_20260418.8427e3bd.pdf";